import { render, staticRenderFns } from "./individual_msgpush_manage.vue?vue&type=template&id=1ca39e52&scoped=true&"
import script from "./individual_msgpush_manage.vue?vue&type=script&lang=js&"
export * from "./individual_msgpush_manage.vue?vue&type=script&lang=js&"
import style0 from "./individual_msgpush_manage.vue?vue&type=style&index=0&id=1ca39e52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca39e52",
  null
  
)

export default component.exports